import React from "react";
import { Button } from "antd";
import { downloadFile } from "../../../components/util";
import { ExportButtons } from "../../../components/ListButtons/exportTo";

interface ButtonsGroupProps {
    filter: any;
    handleAdd: () => void;
}
export function ButtonsGroup({ filter, handleAdd }: ButtonsGroupProps) {
    const exportList = async (type: "pdf" | "xls") => {
        const REPORT_PARAMS = {
            accao: "lista",
            campos: "descricao:200:Designação;designacao:600:Descrição;",
            titulo: "Autorizações do utilizador",
        };

        const { sorter, ...objFilter } = filter;

        if (sorter.columnKey) {
            objFilter["ordenacao_" + sorter.columnKey] = sorter.order === "ascend" ? "ASC" : "DESC";
        }

        await downloadFile("gereautorizacoes.php", {
            ...REPORT_PARAMS,
            ...objFilter,
            saida: type,
            downloadInBrowser: true,
        });
    };

    return (
        <>
            <ExportButtons onExport={exportList} />
            <Button onClick={handleAdd} type="primary" style={{ marginLeft: 8, fontSize: "1rem" }} icon="plus">
                Inserir
            </Button>
        </>
    );
}

export default ButtonsGroup;
